import React from "react";
import FacebookContent from './../Components/FacebookContent.jsx'

export default class SuccessLogin extends React.Component {
	compoonentDidMount = () => {
		window.gtm.loadAccount("successlogin");
	}

	render() {
		let T = window.Texts.login;

		return (
			<div className="success-registered-page">
				<div className="cover">
					<div className="headline">
						<div className="succcess-ordered">
							<p>{T.successLoginTitle}</p>
						</div>
						<h1>{T.successLoginText}</h1>
					</div>
					<div className="inner-750">
						<FacebookContent />
					</div>
				</div>
			</div>
		);
	}
}